import { Dispatch } from 'redux';
import { SYNC_AGGREGATIONS, TOGGLE_AGGREGATION_PANE } from '../action-types';
import { getAggregations } from '../search.api';
import { StateType } from '../../../state/state.types';
import { convertSearchParams, expandAggregations } from '../utils';
import { AggregationsType } from '../../search.types';

export const syncAggregations = (aggregations: AggregationsType) =>
  ({
    type: SYNC_AGGREGATIONS,
    payload: { aggregations },
  } as const);

export const toggleAggregationPane = (
  path: Array<string>,
  isExpanded: boolean,
) =>
  ({
    type: TOGGLE_AGGREGATION_PANE,
    payload: { path, isExpanded },
  } as const);

export const toggleAggregationTree = (
  path: Array<string>,
  isExpanded: boolean,
) => async (dispatch: Dispatch, getState: () => StateType) => {
  dispatch(toggleAggregationPane(path, isExpanded));

  if (isExpanded) {
    const state = getState();
    const params = convertSearchParams({
      ...state.queryParams,
      from: 0,
      userQuery: state.results.query, // user can update input without submit
    });
    delete params.original_query_key;
    const aggregations = expandAggregations(
      state.aggregationsTree.selectedPanes.concat(
        state.queryParams.aggregationsPaths,
      ),
    );

    const updatedParams = {
      ...params,
      ...aggregations,
    };

    const response = await getAggregations(updatedParams);

    dispatch(syncAggregations(response.data));
  }
};

export type AggregationsActions = ReturnType<
  typeof syncAggregations | typeof toggleAggregationPane
>;
